'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import Layout from '@Layout/BackOffice'

import CreationForm from '@/Form/CreationForm'

import { form as _config } from '@Config/Blog/ad_blog'

let config = _.cloneDeep(_config);

const app = window.app;

export default class NewAdminAdBlogPage extends Component
{
	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	render ()
	{
		const props = this.props;

		var output =
		(
			<Layout page_title="Nouvel article promo" history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<CreationForm config={ config } />

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
